interface RadioProps {
  label?: string;
  name?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

import styles from './Radio.module.scss';

const Radio: React.FC<React.PropsWithChildren<RadioProps>> = ({
  label,
  name,
  checked,
  onChange,
  disabled = false,
}) => {
  const ContainerComponent = label ? 'label' : 'div';

  return (
    <ContainerComponent className={styles['radio']} data-disabled={disabled}>
      <span className={styles['radio-input']}>
        <input type="radio" checked={checked} disabled={disabled} name={name} onChange={onChange} />
        <div className={styles['container']}>
          <span className={styles['radio-control']}></span>
        </div>
      </span>
      {label && <span className={styles['radio-label']}>{label}</span>}
    </ContainerComponent>
  );
};

export default Radio;
